<script lang="ts">
    import dayjs from 'dayjs'
    import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
    import { faEnvelope, faPhone, faSms } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    export let byTime = false
    export let slot: {
        time: number
        wa: { items: { name: string; recipient: string; value: number }[] }
        phone: { items: { name: string; recipient: string; value: number }[] }
        email: { items: { name: string; recipient: string; value: number }[] }
        sms: { items: { name: string; recipient: string; value: number }[] }
    }

    function showTime() {
        const time = new Date(slot.time * 1000 * 60 + new Date().getTimezoneOffset() * 1000 * 60)
        return dayjs(time).format('HH:mm')
    }

    function showTimeFromSeconds(items: { name: string; recipient: string; value: number }[], colors: boolean) {
        const seconds: number = items.reduce((acc, el) => acc + el.value, 0)
        let size = seconds > 60 * 60 ? 11 : 14
        let date = new Date(0)
        date.setSeconds(seconds) // specify value for SECONDS here
        if (colors && seconds >= 60) {
            return '<span style="color:lightgreen">' + date.toISOString().substring(size, 19) + '</span>'
        } else {
            return date.toISOString().substring(size, 19)
        }
    }

    function showTotalMessages(items: { name: string; recipient: string; value: number }[]) {
        return items.reduce((acc, el) => acc + el.value, 0) + ' mens'
    }

    function showMessages(total: number) {
        if (total >= 3) {
            return '<span style="color:lightgreen">' + total + '</span>'
        } else {
            return total
        }
    }

    let innerWidth = 0
    let left = '75px'
    function handleMousemove(event) {
        if (event.clientX + 750 > innerWidth) left = '-460px'
    }
</script>

<svelte:window bind:innerWidth />
<div class="root" class:root-line={slot.time % 60 === 0} on:mousemove={handleMousemove}>
    <div class="time">
        {showTime()}
    </div>
    <div class="cell">
        {#if slot.wa.items.length > 0}
            <div class="box">
                <div class="icon">
                    <Fa icon={faWhatsapp} />
                </div>
                <div class="value">{byTime ? showTotalMessages(slot.wa.items) : slot.wa.items.length}</div>
                <div class="detail scroll-dark" style="left:{left}">
                    <div class="row item">
                        <div class="col name nowrap">Nome</div>
                        <div class="col-3 recipient nowrap">WhatsApp</div>
                        <div class="col-3 recipient nowrap text-end">Mens. enviadas</div>
                    </div>
                    {#each slot.wa.items as item}
                        <div class="row item">
                            <div class="col name nowrap">
                                {item.name}
                            </div>
                            <div class="col-3 recipient">
                                {item.recipient}
                            </div>
                            <div class="col-3 recipient nowrap text-end">
                                {@html showMessages(item.value)}
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        {:else}
            <div class="line" />
        {/if}
    </div>
    <div class="cell">
        {#if slot.phone.items.length > 0}
            <div class="box">
                <div class="icon">
                    <Fa icon={faPhone} />
                </div>
                <div class="value">
                    {byTime ? showTimeFromSeconds(slot.phone.items, false) : slot.phone.items.length + ' ligs'}
                </div>
                <div class="detail scroll-dark" style="left:{left}">
                    <div class="row item">
                        <div class="col name nowrap">Nome</div>
                        <div class="col-3 recipient nowrap">Telefone</div>
                        <div class="col-3 duration text-end">Duração</div>
                    </div>
                    {#each slot.phone.items as item}
                        <div class="row item">
                            <div class="col name nowrap">
                                {item.name}
                            </div>
                            <div class="col-3 recipient">
                                {item.recipient}
                            </div>
                            <div class="col-3 duration text-end">
                                {@html showTimeFromSeconds([item], true)}
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        {:else}
            <div class="line" />
        {/if}
    </div>
    <!-- <div class="cell">
        {#if slot.sms.items.length > 0}
            <div class="box">
                <div class="icon">
                    <Fa icon={faSms} />
                </div>
                <div class="value">{slot.sms.items.length}</div>
            </div>
        {:else}
            <div class="line" />
        {/if}
    </div> -->
    <div class="cell">
        {#if slot.email.items.length > 0}
            <div class="box">
                <div class="icon">
                    <Fa icon={faEnvelope} />
                </div>
                <div class="value">{slot.email.items.length}</div>
            </div>
        {:else}
            <div class="line" />
        {/if}
    </div>
</div>

<style>
    .root {
        display: flex;
        height: 36px;
    }
    .root-line {
        border-top: 1px solid #99999940;
    }
    .root .time {
        display: flex;
        font-size: 13px;
        color: #999;
        flex: 0 0 50px;
        padding-left: 4px;
    }
    .root .cell {
        flex: 1 1 10px;
        display: flex;
        justify-content: center;
        position: relative;
    }
    .root .box {
        display: flex;
        background: #99999950;
        border-radius: 4px;
        padding: 2px 4px;
        align-items: center;
        margin-top: 1px;
        margin-bottom: 1px;
        align-self: center;
        font-size: 13px;
    }

    .root .box:hover {
        background: #555 !important;
    }

    .detail {
        position: absolute;
        background-color: #999999;
        padding: 0px 6px;
        border-radius: 4px;
        z-index: 1;
        box-shadow: 3px 3px 5px #111;
        font-size: 13px;
        top: 5px;
        width: 450px;
        visibility: hidden;
        overflow: hidden;
        max-height: 400px;
        overflow-y: auto;
        left: 60px;
    }
    .detail .item {
        display: flex;
        border-bottom: 1px solid #99999940;
        padding: 3px 0px;
    }
    .detail .item:last-child {
        border-bottom: 0px solid #99999940;
    }

    .root .cell:hover .detail {
        visibility: visible;
    }
    .line {
        background: #99999950;
        width: 2px;
    }
    .root .icon {
        margin-right: 6px;
    }
    .root .value {
        flex-grow: 1;
        text-align: center;
    }
</style>
